import { Providers } from '@/app/composition';
import { truentityTheme } from '@/shared/styles';
import EnvironmentBar from '@/shared/ui/components/EnvironmentBar';
import LoadingOverlay from '@/shared/ui/components/LoadingOverlay';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export const AppRoot = () => {
  return (
    <Providers>
      <div className={`inner-root ${truentityTheme}`}>
        <EnvironmentBar />
        <Suspense fallback={<LoadingOverlay active text="Loading..." />}>
          <Outlet />
        </Suspense>
      </div>
    </Providers>
  );
};
